import { AdvancedType } from "src/modules/utils/shared/advanced-type";
import { DbIndex } from "./DbIndex";
import { EnaioCall } from "./EnaioCall";

export class EnaioCallGetDbIndexes extends EnaioCall <DbIndex[]> {
    getModelType(): AdvancedType {
        return AdvancedType.ofClass(DbIndex, 1);
    }

}
